"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWhenSelfChanges = void 0;
const react_1 = require("react");
const useSelf_1 = __importDefault(require("./useSelf"));
function useWhenSelfChanges(cb, realSelf = false) {
    const self = (0, useSelf_1.default)(realSelf);
    const [currentSelfId, setCurrentSelfId] = (0, react_1.useState)();
    (0, react_1.useEffect)(() => setCurrentSelfId[self.id], [self.id]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, react_1.useEffect)(() => cb(), [currentSelfId]);
}
exports.useWhenSelfChanges = useWhenSelfChanges;
exports.default = useWhenSelfChanges;
